import { render, staticRenderFns } from "./Audio_2.vue?vue&type=template&id=2ba971a2&scoped=true"
import script from "./Audio_2.vue?vue&type=script&lang=js"
export * from "./Audio_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba971a2",
  null
  
)

export default component.exports